// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue5355(props) {
    return (
        <svg
            id="_x35_355"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 250 250"
            {...props}
        >
            <defs>
                <style>
                    {
                        '\n      .st0 {\n        stroke: #b7b7b7;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n      }\n\n      .st3 {\n        fill: #5b5b5b;\n      }\n\n      .st1 {\n        stroke: #b3b3b3;\n        stroke-miterlimit: 3.9;\n      }\n\n      .st4, .st5, .st6 {\n        isolation: isolate;\n      }\n\n      .st7, .st2 {\n        stroke-width: .75px;\n      }\n\n      .st7, .st2, .st8, .st9 {\n        stroke: #fff;\n      }\n\n      .st7, .st8, .st9 {\n        fill: #fff;\n      }\n\n      .st10, .st5 {\n        fill: #68836a;\n      }\n\n      .st11 {\n        fill: #ffec5f;\n      }\n\n      .st12 {\n        fill: #a88b49;\n      }\n\n      .st13 {\n        fill: #7f7f7f;\n      }\n\n      .st5 {\n        font-size: 11px;\n      }\n\n      .st5, .st6 {\n        font-family: ArialMT, Arial;\n      }\n\n      .st6 {\n        font-size: 5px;\n      }\n\n      .st8 {\n        stroke-miterlimit: 4;\n        stroke-width: .75px;\n      }\n\n      .st9 {\n        stroke-miterlimit: 4;\n        stroke-width: .75px;\n      }\n\n      .st14 {\n        display: none;\n      }\n    '
                    }
                </style>
            </defs>
            <g id="_x35_3551" data-name="_x35_355">
                <g id="compass">
                    <path
                        className="st3"
                        d="M232.8,206.4l-7.1-5.9-3.9-7,6.4,4.9,4.6,8Z"
                    />
                    <path
                        className="st13"
                        d="M237.2,211.2c-6.4,5.6-16.3,4.9-21.9-1.5-5.6-6.4-4.9-16.3,1.5-21.9,6.4-5.6,16.3-4.9,21.9,1.5,5.6,6.5,5,16.3-1.5,21.9ZM217.7,188.8c-5.9,5.1-6.5,14.1-1.4,20s14.1,6.5,20,1.4,6.5-14.1,1.4-20-14.1-6.5-20-1.4Z"
                    />
                    <path
                        className="st3"
                        d="M227.2,196.6c1.6.1,2.9,1.5,2.8,3.2-.1,1.6-1.5,2.9-3.2,2.8-1.6-.1-2.9-1.5-2.8-3.2.2-1.7,1.6-3,3.2-2.8ZM220,193.3l-2-2.3.4-.3,2.5.7-1.4-1.6.4-.3,2,2.3-.4.3-2.5-.7,1.4,1.6-.4.3Z"
                    />
                    <path
                        className="st11"
                        d="M227.1,197.9c.9.1,1.6.9,1.5,1.8-.1.9-.9,1.6-1.8,1.5-.9-.1-1.6-.9-1.5-1.8.1-.9.9-1.6,1.8-1.5Z"
                    />
                </g>
                <g id="distances">
                    <g id="right" className="st4">
                        <g className="st4">
                            <g className="st4">
                                <text
                                    className="st5"
                                    transform="translate(224.91 93.99)"
                                >
                                    <tspan x={0} y={0}>
                                        340
                                    </tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g id="right-center" className="st4">
                        <g className="st4">
                            <g className="st4">
                                <text
                                    className="st5"
                                    transform="translate(183.69 55.53)"
                                >
                                    <tspan x={0} y={0}>
                                        380
                                    </tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g id="center" className="st4">
                        <g className="st4">
                            <g className="st4">
                                <text
                                    className="st5"
                                    transform="translate(112.27 27.24)"
                                >
                                    <tspan x={0} y={0}>
                                        415
                                    </tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g id="left-center" className="st4">
                        <g className="st4">
                            <g className="st4">
                                <text
                                    className="st5"
                                    transform="translate(47.79 55.53)"
                                >
                                    <tspan x={0} y={0}>
                                        380
                                    </tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g id="left" className="st4">
                        <g className="st4">
                            <g className="st4">
                                <text
                                    className="st5"
                                    transform="translate(9.19 93.98)"
                                >
                                    <tspan x={0} y={0}>
                                        340
                                    </tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                </g>
                <g id="field">
                    <path
                        id="Outfield"
                        className="st12"
                        d="M205.8,125l1.55,4.8-16.75,29.5-47.16,52.13s-7.71,10.7-18.64,10.7-18.53-12.25-18.53-12.25l-26.75-29.7-19.15-20.88-17.08-29.5,1.31-5.16-19.78-21.97,1.76-1.75,1.78-1.73,1.76-1.75,1.76-1.76,1.76-1.76,1.77-1.77,1.77-1.77,1.78-1.78,1.79-1.79,1.8-1.8,1.81-1.81,1.82-1.82,1.84-1.84,1.85-1.85,1.87-1.87,1.89-1.89,1.9-1.9,1.93-1.93,1.95-1.95,1.97-1.97,2-2,2.02-2.02,2.05-2.05,2.08-2.08,2.12-2.12,2.15-2.15,2.19-2.19,2.22-2.23,2.27-2.27,2.31-2.32,2.36-2.36,2.41-2.42,2.68-1.46,2.86-.66,2.87-.66,2.87-.66,2.88-.66,2.89-.67,2.9-.67,2.91-.67,2.92-.67,2.94-.68,2.96-.68,2.98-.69,3-.68,3,.72,2.94,1.7,2.89,1.67,2.84,1.64,2.79,1.61,2.74,1.59,2.7,1.56,2.66,1.54,2.62,1.52,2.59,1.5,2.56,1.48,2.63.95,2.94-.44,2.98-.45,3.03-.45,2.56,1.31,2.26,2.24,2.22,2.2,2.18,2.17,2.14,2.14,2.1,2.11,2.07,2.07,2.04,2.04,2.01,2.01,1.99,1.99,1.96,1.96,1.94,1.94,1.91,1.92,1.89,1.9,1.88,1.88,1.86,1.86,1.84,1.84,1.83,1.83,1.81,1.82,1.8,1.8,1.79,1.79,1.78,1.78,1.77,1.77,1.76,1.77,1.76,1.76,1.75,1.75,1.75,1.75,1.75,1.74,1.77,1.72,1.75,1.74-19.23,21.79h-.02Z"
                    />
                    <path
                        id="grass"
                        className="st10"
                        d="M198.8,121.61s11.44-12.04,12.42-13.3,1.48-5.57-.77-7.71-25.76-25.65-27.8-27.84-16.4-16.56-16.4-16.56l-8.75.84-32.28-17.22-31.47,7.39s-53.78,53.36-55.04,54.55-1.41,6.34-.42,7.46,13.23,13.94,13.23,13.94l-1.87,4.76s14.62,25.93,15.46,27.33,26.54,29.14,29.56,32.59,17.67,20.2,19.92,22.17,6.3,5.63,10.22,5.63,7.51-1.2,9.98-4.08,50.05-54.83,51.03-55.89,15.13-27.03,15.13-27.03l-2.14-7.04h0Z"
                    />
                    <path
                        id="infield_sand"
                        className="st12"
                        d="M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z"
                    />
                </g>
                <g id="persistent">
                    <g id="mound">
                        <path
                            id="pitching-mound"
                            className="st12"
                            d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4-1.4-1.5-3.9-1.5-5.4,0Z"
                        />
                        <path
                            id="pitching-rubber"
                            className="st7"
                            d="M123.2,176.6h4v1.6h-4v-1.6Z"
                        />
                    </g>
                    <g id="lines">
                        <path
                            id="left-foul-line"
                            className="st2"
                            d="M125.2,203.2L24.75,102.75"
                        />
                        <path
                            id="right-foul-line"
                            className="st2"
                            d="M125.2,203.2l99.86-99.96"
                        />
                    </g>
                    <g id="bases">
                        <rect
                            id="third-base"
                            className="st9"
                            x={99.2}
                            y={175.12}
                            width={3}
                            height={3}
                            transform="translate(-95.38 122.87) rotate(-44.98)"
                        />
                        <rect
                            id="first-base"
                            className="st9"
                            x={148.11}
                            y={175.21}
                            width={3}
                            height={3}
                            transform="translate(-81.13 157.47) rotate(-44.98)"
                        />
                        <rect
                            id="second-base"
                            className="st8"
                            x={123.71}
                            y={148.62}
                            width={3}
                            height={3}
                            transform="translate(-69.48 132.54) rotate(-45.01)"
                        />
                        <polygon
                            id="home"
                            className="st7"
                            points="126.7 201.8 125.2 203.4 123.7 201.8 123.7 200.3 126.7 200.3 126.7 201.8"
                        />
                    </g>
                </g>
            </g>
            <g id="grid" className="st14">
                <g>
                    <g id="numbers">
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <g className="st4">
                                                    <text
                                                        className="st6"
                                                        transform="translate(91.08 184.02) rotate(-44.2)"
                                                    >
                                                        <tspan x={0} y={0}>
                                                            90
                                                        </tspan>
                                                    </text>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <g className="st4">
                                                    <text
                                                        className="st6"
                                                        transform="translate(56.58 153.72) rotate(-44.2)"
                                                    >
                                                        <tspan x={0} y={0}>
                                                            200
                                                        </tspan>
                                                    </text>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <g className="st4">
                                                    <text
                                                        className="st6"
                                                        transform="translate(71.08 168.32) rotate(-44.2)"
                                                    >
                                                        <tspan x={0} y={0}>
                                                            150
                                                        </tspan>
                                                    </text>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <g className="st4">
                                                    <text
                                                        className="st6"
                                                        transform="translate(80.48 177.62) rotate(-44.2)"
                                                    >
                                                        <tspan x={0} y={0}>
                                                            120
                                                        </tspan>
                                                    </text>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <g className="st4">
                                                    <text
                                                        className="st6"
                                                        transform="translate(41.68 138.92) rotate(-44.2)"
                                                    >
                                                        <tspan x={0} y={0}>
                                                            250
                                                        </tspan>
                                                    </text>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <g className="st4">
                                                    <text
                                                        className="st6"
                                                        transform="translate(27.58 123.92) rotate(-44.2)"
                                                    >
                                                        <tspan x={0} y={0}>
                                                            300
                                                        </tspan>
                                                    </text>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <g className="st4">
                                                    <text
                                                        className="st6"
                                                        transform="translate(12.78 109.12) rotate(-44.2)"
                                                    >
                                                        <tspan x={0} y={0}>
                                                            350
                                                        </tspan>
                                                    </text>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <g className="st4">
                                                    <text
                                                        className="st6"
                                                        transform="translate(15.08 75.82) rotate(-44.2)"
                                                    >
                                                        <tspan x={0} y={0}>
                                                            400
                                                        </tspan>
                                                    </text>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <g className="st4">
                                                    <text
                                                        className="st6"
                                                        transform="translate(15.08 49.32) rotate(-44.2)"
                                                    >
                                                        <tspan x={0} y={0}>
                                                            450
                                                        </tspan>
                                                    </text>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <g className="st4">
                                                    <text
                                                        className="st6"
                                                        transform="translate(15.08 24.52) rotate(-44.2)"
                                                    >
                                                        <tspan x={0} y={0}>
                                                            500
                                                        </tspan>
                                                    </text>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                    <g id="surface29">
                        <path className="st1" d="M125.5,203.8L-22.5,55.8" />
                        <path className="st1" d="M124.8,203.8L272.8,55.8" />
                        <path className="st0" d="M125.1,203.5L45.4,10.9" />
                        <path className="st0" d="M125.1,203.5V-4.9" />
                        <path className="st0" d="M125.1,203.5L204.9,10.9" />
                    </g>
                    <path
                        id="_x31_00-line"
                        className="st1"
                        d="M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
                    />
                    <path
                        id="_x32_00-line"
                        className="st1"
                        d="M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5s43.8,9.3,58.8,24.4"
                    />
                    <path
                        id="_x39_0-line"
                        className="st1"
                        d="M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1s19.7,4.2,26.5,11"
                    />
                    <path
                        id="_x31_20-line"
                        className="st1"
                        d="M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4s32.8,7,44.1,18.3"
                    />
                    <path
                        id="_x32_50-line"
                        className="st1"
                        d="M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6s54.7,11.6,73.6,30.5"
                    />
                    <path
                        id="_x33_00-line"
                        className="st1"
                        d="M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
                    />
                    <path
                        id="_x33_50-line"
                        className="st1"
                        d="M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1s76.6,16.3,103,42.7"
                    />
                    <path
                        id="_x34_50-line"
                        className="st1"
                        d="M-7.4,70.9C26.5,36.9,73.4,15.9,125.2,15.9s98.6,21,132.5,54.9"
                    />
                    <path
                        id="_x34_00-line"
                        className="st1"
                        d="M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9s87.6,18.6,117.7,48.8"
                    />
                    <path
                        id="_x35_00-line"
                        className="st1"
                        d="M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9s109.5,23.3,147.2,61"
                    />
                </g>
            </g>
        </svg>
    )
}
export default Venue5355
